// Resume47.js
import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Grid,
  Avatar,
} from '@mui/material';
import {
  Phone as PhoneIcon,
  Email as EmailIcon,
  LocationOn as LocationOnIcon,
} from '@mui/icons-material';

const Resume47 = ({ color = "#0d47a1" }) => {
  return (
    <Box
      sx={{
        minHeight: '100vh',
        bgcolor: '#f0f4f8',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'flex-start',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          width: '210mm',
          minHeight: '297mm',
          bgcolor: 'white',
          overflow: 'hidden',
          position: 'relative',
          borderRadius: 0,
          boxShadow: 'none',
        }}
      >
        {/* Light blue header strip */}
        <Box
          sx={{
            height: '180px',
            bgcolor: '#e3f2fd',
            position: 'relative',
          }}
        >
          {/* Circular photo overlapping */}
          <Avatar
            src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&auto=format&fit=crop&q=80"
            alt="Dani Martinez"
            sx={{
              width: 140,
              height: 140,
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              border: '8px solid white',
              boxShadow: '0 6px 20px rgba(0,0,0,0.15)',
            }}
          />
        </Box>

        {/* Main content area */}
        <Box sx={{ px: { xs: 2, md: 4 }, pt: 14, pb: 8 }}>
          {/* Name & Title - centered */}
          <Box sx={{ textAlign: 'center', mb: 5 }}>
            <Typography
              variant="h4"
              component="h1"
              sx={{
                fontWeight: 700,
                color: color,
                fontSize: { xs: '2.1rem', md: '2.6rem' },
                letterSpacing: '0.5px',
                lineHeight: 1.1,
                mb: 0.5,
              }}
            >
              DANI MARTINEZ
            </Typography>

            <Typography
              variant="h6"
              sx={{
                color: color,
                fontWeight: 600,
                fontSize: { xs: '1.15rem', md: '1.35rem' },
                letterSpacing: '1px',
                textTransform: 'uppercase',
              }}
            >
              WEB DEVELOPER
            </Typography>
          </Box>

          {/* Contact icons - centered */}
          <Grid
            container
            spacing={4}
            justifyContent="center"
            sx={{ mb: 6, color: '#444' }}
          >
            <Grid item>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <PhoneIcon sx={{ color, fontSize: 18 }} />
                <Typography sx={{ fontSize: '0.92rem' }}>123-456-7890</Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <EmailIcon sx={{ color, fontSize: 18 }} />
                <Typography sx={{ fontSize: '0.92rem' }}>
                  hello@reallygreatsite.com
                </Typography>
              </Box>
            </Grid>
            <Grid item>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <LocationOnIcon sx={{ color, fontSize: 18 }} />
                <Typography sx={{ fontSize: '0.92rem' }}>
                  123 Anywhere St., Any City
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* TWO COLUMN LAYOUT - You can adjust these ratios */}
          {/* Option 1: Left 30% / Right 70% */}
          <Grid container spacing={4}>
            {/* LEFT COLUMN - 30% width */}
<Grid item xs={2} md={3.6} sx={{ width: { xs: '45%', md: 'auto' ,lg:'45%'} }}>              {/* SKILLS */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: color,
                    fontWeight: 700,
                    mb: 1.5,
                    pb: 0.8,
                    borderBottom: `2px solid ${color}`,
                    fontSize: '1rem',
                  }}
                >
                  SKILLS
                </Typography>
                <Typography
                  component="div"
                  sx={{ lineHeight: 2, fontSize: '0.88rem', mt: 1.5 }}
                >
                  • Web Design<br />
                  • Design Thinking<br />
                  • Front End Coding<br />
                  • Problem-Solving<br />
                  • Computer Literacy<br />
                  • Project Management Tools<br />
                  • Strong Communication
                </Typography>
              </Box>

              {/* AWARD */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: color,
                    fontWeight: 700,
                    mb: 1.5,
                    pb: 0.8,
                    borderBottom: `2px solid ${color}`,
                    fontSize: '1rem',
                  }}
                >
                  AWARD
                </Typography>
                <Typography
                  component="div"
                  sx={{ lineHeight: 1.9, fontSize: '0.88rem', mt: 1.5 }}
                >
                  • Top 3 Web Design Competition (2019)<br />
                  • Best Creative Web Designer Competition (2020)<br />
                  • Top 3 Creative Social Branding of Influencers (2022)
                </Typography>
              </Box>

              {/* REFERENCE */}
              <Box>
                <Typography
                  variant="h6"
                  sx={{
                    color: color,
                    fontWeight: 700,
                    mb: 1.5,
                    pb: 0.8,
                    borderBottom: `2px solid ${color}`,
                    fontSize: '1rem',
                  }}
                >
                  REFERENCE
                </Typography>

                <Box sx={{ mt: 2 }}>
                  <Typography
                    variant="subtitle2"
                    sx={{ fontWeight: 600, fontSize: '0.9rem' }}
                  >
                    HANNAH MORALES
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>
                    Manager, Really Great Site
                  </Typography>
                  <Typography variant="body2" sx={{ fontSize: '0.85rem', color: '#555' }}>
                    hello@reallygreatsite.com
                  </Typography>
                </Box>

              </Box>
            </Grid>

            {/* RIGHT COLUMN - 70% width */}
            <Grid item xs={4} md={4.4} sx={{ width: { xs: '45%', md: 'auto' ,lg:'45%'} }}>
              {/* SUMMARY */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: color,
                    fontWeight: 700,
                    mb: 1.5,
                    pb: 0.8,
                    borderBottom: `2px solid ${color}`,
                    fontSize: '1rem',
                  }}
                >
                  SUMMARY
                </Typography>
                <Typography
                  variant="body1"
                  sx={{
                    mt: 1.5,
                    lineHeight: 1.7,
                    fontSize: '0.88rem',
                    color: '#333',
                  }}
                >
                  I am a qualified and professional web developer with five years of experience in
                  database administration and website design. Strong creative and analytical skills.
                  Team player with an eye for detail.
                </Typography>
              </Box>

              {/* EXPERIENCE */}
              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="h6"
                  sx={{
                    color: color,
                    fontWeight: 700,
                    mb: 1.5,
                    pb: 0.8,
                    borderBottom: `2px solid ${color}`,
                    fontSize: '1rem',
                  }}
                >
                  EXPERIENCE
                </Typography>

                <Box sx={{ mt: 2, mb: 3 }}>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      color: color,
                      fontSize: '0.95rem',
                    }}
                  >
                    APPLICATIONS DEVELOPER
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#555',
                      fontStyle: 'italic',
                      fontSize: '0.85rem',
                      mb: 0.8,
                    }}
                  >
                    Really Great Company • 2016 – Present
                  </Typography>
                  <Typography variant="body2" sx={{ lineHeight: 1.6, fontSize: '0.88rem' }}>
                    • Database administration and website design<br />
                    • Built the logic for a streamlined ad-serving platform that scaled<br />
                    • Educational institutions and online classroom management
                  </Typography>
                </Box>

                <Box>
                  <Typography
                    variant="subtitle1"
                    sx={{
                      fontWeight: 700,
                      color: color,
                      fontSize: '0.95rem',
                    }}
                  >
                    WEB CONTENT MANAGER
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: '#555',
                      fontStyle: 'italic',
                      fontSize: '0.85rem',
                      mb: 0.8,
                    }}
                  >
                    Really Great Company • 2014 – 2016
                  </Typography>
                  <Typography variant="body2" sx={{ lineHeight: 1.6, fontSize: '0.88rem' }}>
                    • Database administration and website design<br />
                    • Built the logic for a streamlined ad-serving platform that scaled<br />
                    • Educational institutions and online classroom management
                  </Typography>
                </Box>
              </Box>

           
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </Box>
  );
};

export const resumeMeta = {
  hasPhoto: true,
  columns: 2,
  colorOptions: [
    { value: "#0d47a1", label: "Deep Blue" },
    { value: "#4527a0", label: "Deep Purple" },
    { value: "#00695c", label: "Deep Teal" },
    { value: "#d84315", label: "Fiery Orange" },
    { value: "#0277bd", label: "Strong Blue" }
  ]
};

export default Resume47;